<template>
    <a-row justify="space-between"
           align="middle">
        <a-col>
            <h3 class="n-c-base n-line-height-1 n-m-0">我的项目</h3>
        </a-col>
        <a-col>
            <a-row :gutter="10">
                <a-col>
                    <a-button type="primary"
                              @click="showAddProject = true;projecteditTitle = '新增工作项目';">新建</a-button>
                </a-col>
                <a-col>
                    <a-popconfirm title="确认删除选中项目？"
                                  ok-text="删除"
                                  placement="leftTop"
                                  cancel-text="取消"
                                  :disabled="project.selectedRowKeys.length <= 0"
                                  @confirm="deleteProject">
                        <a-button type="primary"
                                  danger
                                  :disabled="project.selectedRowKeys.length <= 0">删除</a-button>
                    </a-popconfirm>
                </a-col>
                <a-col>
                    <a-button :disabled="project.selectedRowKeys.length <= 0"
                              @click="completeProject">归档</a-button>
                </a-col>
            </a-row>

        </a-col>
    </a-row>

    <div class="n-bg-1 n-p-2 n-body-shadow n-mt-2">
        <a-table :dataSource="project.datas"
                 :columns="project.columns"
                 :row-selection="{ fixed: true, selectedRowKeys: project.selectedRowKeys, onChange: onSelectChange }"
                 :bordered="true"
                 :scroll="{ x: 1000 }"
                 :loading="project.loading"
                 :pagination="project.pageInfo"
                 tableLayout="fixed"
                 size="small"
                 @change="tableChange">
            <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex == 'name'">
                    <a-row align="middle"
                           class="n-pointer"
                           :gutter="[5]">
                        <a-col>
                            <i class="n-icon n-icon-project n-icon-size-20 n-c-base"></i>
                        </a-col>
                        <a-col>{{ record.name }}</a-col>
                    </a-row>
                </template>

                <template v-if="column.dataIndex == 'status'">
                    <a-row align="middle"
                           :gutter="[5]">
                        <a-col>
                            <i class="n-icon n-icon-size-20 c-status"
                               :class="getStatus(record.status).icon"></i>
                        </a-col>
                        <a-col class="n-f-2">{{ getStatus(record.status).title }}</a-col>
                    </a-row>
                </template>

                <template v-if="column.dataIndex === 'ctrl'">
                    <a-button type="primary"
                              size="small"
                              class="n-mr-2"
                              @click.stop="editProject(record)">编辑</a-button>
                    <a-button size="small"
                              v-if="record.follow"
                              :loading="record.loading"
                              @click.stop="changeFollow(record)">取消关注</a-button>
                    <a-button type="primary"
                              size="small"
                              v-else
                              :loading="record.loading"
                              @click.stop="changeFollow(record)">关注</a-button>
                </template>
            </template>
        </a-table>
    </div>

    <AddProjectBox :visible="showAddProject"
                   :title="projecteditTitle"
                   ref="addProjectBox"
                   @close="showAddProject = false"
                   @success="getProject"></AddProjectBox>
</template>
<script >
    import { createVNode } from 'vue';
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    import AddProjectBox from '@/components/AddProjectBox'

    export default nui.extend(true, {}, nui.extendVue, {
        name: 'MyProject',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),

        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                project: {
                    loading: false,
                    datas: [],
                    pageInfo: {
                        total: 0,
                        current: 1,
                        pageSize: 10,
                        showSizeChanger: true,
                        size: 'middle'
                    },
                    columns: [
                        {
                            title: '项目名称',
                            dataIndex: 'name',
                            key: 'name',
                            customCell: (record) => {
                                return {
                                    onClick: (e) => {
                                        this.goTask(record)
                                    }
                                }
                            }
                        },
                        { title: '状态', dataIndex: 'status', key: 'status', width: 90 },
                        { title: '创建人', dataIndex: 'creator', key: 'creator', width: 90 },
                        { title: '创建日期', dataIndex: 'date', key: 'date', width: 90 },
                        // { title: '责任部门', dataIndex: 'dept', key: 'dept', width: 110 },
                        { title: '操作', dataIndex: 'ctrl', key: 'ctrl', width: 150, fixed: 'right' }
                    ],
                    selectedRowKeys: [],
                    selectedRows: [],
                },


                showAddProject: false,
                projecteditTitle: '新增工作项目',
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            NMounted () {
                this.getProject()
            },
            /**
             * @description 修改关注状态
             */
            changeFollow (data) {
                data.loading = true;

                this.request(this.API.follow, {
                    params: {
                        projectId: data.id
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        data.loading = false;
                        data.follow = !data.follow;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 获取项目
             */
            getProject () {
                this.project.loading = true;

                this.request(this.API.myProject, {
                    method: 'post',
                    data: {
                        pageCount: this.project.pageInfo.current,
                        pageSize: this.project.pageInfo.pageSize
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.project.datas = res.data.list.map(item => {
                            return {
                                key: item.id,
                                id: item.id,
                                name: item.projectName,
                                status: item.progressStatus,
                                creator: item.createUserName,
                                date: this.parseUTC(item.createTime),
                                dept: item.deptName || '-',
                                follow: item.careStatus == 1
                            }
                        })

                        this.project.pageInfo.total = res.data.total

                        this.project.loading = false;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 分页
             */
            tableChange (page) {
                this.project.pageInfo = page;
                this.getProject()
            },
            /**
             * @description 删除项目
             */
            deleteProject () {
                this.project.loading = true;

                var deletePromise = [];

                for (var i = 0; i < this.project.selectedRowKeys.length; i++) {
                    deletePromise.push(this.request(this.API.deleteProject, {
                        params: { projectId: this.project.selectedRowKeys[i] }
                    }))
                }

                Promise.all(deletePromise).then(res => {
                    res = res.map((item, index) => {
                        item.name = this.project.selectedRows[index].name;
                        return item
                    })

                    var error = res.filter(item => item.code != this.REQUEST_SUCCESS_CODE),
                        errorNode = error.map((item, index) => createVNode('p', {}, item.name + '：' + item.msg));

                    if (error.length > 0) {
                        this.warning(createVNode('div', {}, [createVNode('p', {}, error.length + '个项目删除失败:')].concat(errorNode)))
                    } else {
                        this.success('删除成功')
                    }

                    if (this.project.pageInfo.current > 1 && this.project.datas.length - this.project.selectedRowKeys.length <= 0) {
                        this.project.pageInfo.current -= 1
                    }

                    this.onSelectChange([]);
                    this.getProject()
                })
            },
            /**
             * @description 归档项目
             */
            completeProject () {
                this.project.loading = true;

                this.request(this.API.completeProject, {
                    method: 'post',
                    data: this.project.selectedRowKeys
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('归档成功')

                        if (this.project.pageInfo.current > 1 && this.project.datas.length - this.project.selectedRowKeys.length <= 0) {
                            this.project.pageInfo.current -= 1
                        }

                        this.onSelectChange([]);
                        this.getProject()
                    } else {
                        this.project.loading = false;
                        this.error(res.msg)
                    }
                })
            },
            onSelectChange (selectedRowKeys, selectedRows) {
                this.project.selectedRowKeys = selectedRowKeys
                this.project.selectedRows = selectedRows
            },
            goTask (data) {
                this.$router.push({ name: 'projectTask', query: { id: data.id } })
            },
            editProject (data) {
                this.showAddProject = true;
                this.projecteditTitle = '编辑工作项目';
                this.$nextTick(() => {
                    this.$refs.addProjectBox.getDetail(data.key, true)
                })
            }
        }),
        components: {
            AddProjectBox
        },
        ...nui.extendVue.extendLife
    })
</script>
<style lang="scss">
</style>